import React, { useEffect } from "react"
import { useParams } from "react-router-dom";
import { useState } from "react";
import { Box } from "@mui/system";
import { AppBar, Tab, useTheme, Tabs, CssBaseline, CircularProgress, Divider, Button, FormControl } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import OpenDataMap from "./OpenDataMap";
import HeatmapContainer from "../Dashboard/HeatmapContainer";
import Statistics from "../Statistics";
import IniziativeData from "./IniziativeData";
import ShopManagement from "../Vendor/Shop/ShopManagement";
import OrganizationRanksManager from "../Dashboard/OrganizationRanksManager";
import GeneralRank from "./GeneralRank";
import Grid from "@mui/material/Grid";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import makeStyles from "@mui/styles/makeStyles";
import { useGetOrganization, useGetOrganizationSettings, useGetPublicOrganization, useGetPublicOrganizationSettings } from "../../services/ContentManager";
import ResponsiveCircularLoading from "../../components/ResponsiveCircularLoading";
import Typography from "@mui/material/Typography";
import logo from "../../images/pinbike.gif";
import logoEIT from "../../images/logo-EIT.svg";
import logoEU from "../../images/EU-nl.png";
import OpenDataShops from "./OpenDataShops";
import dayjs from "dayjs";
import InfoGrid from "../../components/InfoGrid";
import StartIconButton from "../../components/buttons/StartIconButton";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { MenuButton } from "../../components/buttons/MenuButton";
import LanguageSelect from "../../components/LanguageSelect";

function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            style={{ height: 'calc(100% - 48px)' }}
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3, height: '100%' }}>
                    {children}
                </Box>
            )}
        </div>
    );
}


const StyledTab = styled((props) => <Tab {...props} />)(
    ({ theme }) => ({
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        // color: theme.palette.secondary.light,
        // '&.Mui-selected': {
        //     color: '#fff',
        // },
    }),
);

const useStyles = makeStyles(theme => ({
    page: {
        padding: theme.spacing(2)
    },
    filterBar: {
        padding: theme.spacing(4),
        paddingBottom: 0
    },
    title: {
        paddingLeft: theme.spacing(2),
        color: theme.palette.primary.main,
        fontWeight: "bold",
        fontSize: 40
    },
    notificationLogo: {
        width: "5vw",
        color: theme.palette.primary.main,
        fontSize: 60,
    },
    initiativeLogo: {
        maxWidth: "80vw",
        maxHeight: "17vh",
    },
}));


export default function OpenDataPage() {
    const { t, i18n } = useTranslation();
    const [value, setValue] = useState('map');
    const theme = useTheme();
    let classes = useStyles();
    let { id } = useParams();
    let { status, organization } = useGetPublicOrganization(id);
    const { settings = [], status: settingsStatus } = useGetPublicOrganizationSettings(id, {
        refetchOnWindowFocus: false,
        refetchOnmount: false,
        refetchOnReconnect: false,
        retry: false,
        staleTime: dayjs.duration(1, 'day').asMilliseconds(),
    });
    const [selectedPeriod, setSelectedPeriod] = useState({})

    let interval = {
        start: (settings.find(s => s.organizationSetting === 'startDateUrbanPoints') || {}).value,
        end: (settings.find(s => s.organizationSetting === 'endDateUrbanPoints') || {}).value
    }


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const getMonthsFromDateInterval = (interval) => {
        if (interval) {
            let months = [];

            let start = dayjs(interval.start);
            let end = dayjs(interval.end);

            let currentInterval = {
                start: start.add(-1, 'day'),
                end: start.add(-1, 'day')
            }

            while (currentInterval.end.isBefore(end)) {
                let nextDay = currentInterval.end.add(1, 'day');
                currentInterval = {
                    start: nextDay,
                    end: nextDay.endOf('month'),
                }
                months.push({
                    text: currentInterval.start.format('MMMM YYYY'),
                    value: {
                        start: currentInterval.start.format('YYYY-MM-DD'),
                        end: currentInterval.end.format('YYYY-MM-DD'),
                        label: currentInterval.start.format('MMMM YYYY'),
                    }
                })
            }

            //correggere l'ultimo elemento dell'array
            months.at(-1).end = interval.end;
            
            //Inserire l'elemento tutto il periodo
            months.push({
                text: t('allIniziativePeriod'),
                value: {
                    start: start.format('YYYY-MM-DD'),
                    end: end.format('YYYY-MM-DD'),
                    label: t('allIniziativePeriod'),
                }
            })
            return months;
        }
        return [];
    }

    useEffect(() => {
        if (settingsStatus === 'success') {
            setSelectedPeriod(getMonthsFromDateInterval(interval)[0].value)
        }
    }, [settingsStatus])

    if (status === "loading") return <ResponsiveCircularLoading />

    const isBicification = (settings.find(s => s.organizationSetting === 'isBicification') || {}).value;
    const openDataForm = (settings.find(s => s.organizationSetting === 'openDataUserForm') || {}).value;
    return (
        <Grid container sx={{
            display: 'flex',
            minHeight: '100vh',
            maxWidth: '100vw'
        }}>
            <CssBaseline />
            <main style={{
                flexGrow: 1,
                minHeight: '100%',
            }}>
                <Box sx={{
                    maxWidth: theme.breakpoints.values.lg,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    p: 3,
                }}>
                    <header>
                        <Grid container sx={{ mb: 3 }}>
                            <Grid item xs={12} align={"center"}>
                                <Typography variant={'h3'} sx={{
                                    padding: theme.spacing(1),
                                    fontWeight: "bold",
                                    color: theme.palette.primary.main,
                                    textAlign: "center",
                                    textTransform: 'uppercase'
                                }}
                                >
                                    {organization.title}
                                </Typography>
                            </Grid>
                            {organization.initiativeLogo ?
                                <Grid item xs={12} align={"center"}>
                                    <img className={classes.initiativeLogo} src={organization.initiativeLogo} />
                                </Grid>
                                :
                                <Grid container direction="row" justifyContent="center" alignItems="center">
                                    {organization.notificationLogo ?
                                        <img className={classes.notificationLogo} src={organization.notificationLogo} />
                                        :
                                        <AccountBalanceIcon className={classes.notificationLogo} sx={{ fontSize: 60 }} />}
                                    <div className={classes.title}>{organization.title}</div>
                                </Grid>
                            }
                        </Grid>
                        {
                            interval.start && <Grid container direction='column' sx={{ mb: 3 }} >
                                <Grid item>
                                    <Typography variant={'h6'} sx={{ px: 1 }} align='center'>
                                        {t('iniziativePeriod')}
                                    </Typography>
                                </Grid>

                                <Grid item sx={{
                                    fontSize: '1.3em',
                                    '& .MuiBox-root': {
                                        borderBottom: 'none',
                                        m: 0
                                    }
                                }}>
                                    <InfoGrid infos={[
                                        {
                                            isDate: true,
                                            field: 'start',
                                            label: t('startDate'),
                                            xs: '6',
                                            md: 'auto'
                                        }, {
                                            isDate: true,
                                            field: 'end',
                                            label: t('endDate'),
                                            xs: '6',
                                            md: 'auto'
                                        },
                                    ]} data={interval} />
                                </Grid>
                            </Grid>
                        }
                        <Grid container direction='column' sx={{ mb: 3 }}>
                            <Grid item>
                                <Typography variant={'h6'} sx={{ px: 1 }} align='center'>
                                    {t('showedValuesMonth')}
                                </Typography>
                            </Grid>

                            <Grid item textAlign={'center'} sx={{
                                fontSize: '1.3em',
                                '& .MuiBox-root': {
                                    borderBottom: 'none',
                                    m: 0
                                }
                            }}>
                                <MenuButton
                                    title={selectedPeriod.label}
                                    items={getMonthsFromDateInterval(interval)}
                                    onChange={v => setSelectedPeriod(v)}
                                />
                            </Grid>
                        </Grid>
                    </header>
                </Box>


                <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 2 }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        // variant={'fullWidth'}
                        centered
                    >
                        {/* <StyledTab label={t('heatmap')} value='heatmap' /> */}
                        <StyledTab label={t('map')} value='map' />
                        <StyledTab label={t('statistics')} value='statistics' />
                        <StyledTab label={t('shops')} value='shops' />
                        {/* {process.env.REACT_APP_ENVIRONMENT !== "production" && <StyledTab label={t('generalRanking')} value='rank' />} */}
                    </Tabs>
                </Box>

                <Box sx={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    p: 3,
                }}>
                    {/* <TabPanel value={value} index={'heatmap'}>
                        <OpenDataMap showHeatmap />
                    </TabPanel> */}
                    <TabPanel value={value} index={'map'}>
                        <OpenDataMap interval={selectedPeriod} organization={organization} />
                    </TabPanel>
                    <TabPanel value={value} index={'statistics'}>
                        <Statistics disableDateInterval overrideInterval={selectedPeriod} />
                    </TabPanel>
                    <TabPanel value={value} index={'shops'}>
                        <OpenDataShops></OpenDataShops>
                        {/*    todo:selezionare solo gli shop che hanno partecipato all' iniziativa e inserire i filtri per tag*/}
                    </TabPanel>
                    {/* <TabPanel value={value} index={'rank'}>
                        <GeneralRank />
                    </TabPanel> */}
                </Box>

                <Divider sx={{ py: 1 }} />

                <Grid container alignItems={'center'} sx={{ p: 3 }}>
                    <Grid item flexGrow={1}></Grid>

                    <Grid item sx={{ p: 2 }} textAlign={'center'}>
                        <Typography variant={'h6'} >{t('regulation')}</Typography>
                    </Grid>
                    <Grid item sx={{ p: 2 }} textAlign={'center'}>
                        <StartIconButton title={t('openPdf')} startIcon={<PictureAsPdfIcon />}
                            href={organization.termsConditions}
                            target="_blank" />
                    </Grid>

                    <Grid item flexGrow={0.3}></Grid>

                    {(dayjs(interval.end)).diff(dayjs(new Date())) > 0 && 
                        <> <Grid item sx={{ p: 2 }} textAlign={'center'}>
                            <Typography variant={'h6'} >{t('userForm')}</Typography>
                        </Grid>
                            <Grid item sx={{ p: 2 }} textAlign={'center'}>
                                <Button
                                    variant="contained"
                                    src={openDataForm}
                                    disabled={!openDataForm}
                                >
                                    {t('join')}
                                </Button>
                            </Grid>
                        </>
                    }

                    <Grid item flexGrow={0.3}></Grid>
                    <Grid item sx={{ p: 2 }} textAlign={'center'}>
                        <Typography variant={'h6'} >{t('pageLanguage')}</Typography>
                    </Grid>
                    <Grid item sx={{ p: 2 }} textAlign={'center'}>

                        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                            <LanguageSelect value={i18n.language} onChange={({ target }) => i18n.changeLanguage(target.value)} color='black' />
                        </FormControl>
                    </Grid>

                    <Grid item flexGrow={1}></Grid>
                </Grid>

                <footer style={{ marginBottom: '0px' }}>
                    <Grid container alignItems={'center'} justifyContent={'space-evenly'}
                        sx={{ bgcolor: '#32323a57', p: 2 }}>
                        {true &&
                            <Grid item md={8} sx={{ py: { md: 2, xs: 1 }, px: { md: 3, xs: 1 } }}>
                                <Box sx={{ width: '100%', maxWidth: '50em', ml: 3 }}>
                                    <img style={{ width: 'calc(50% - 8px)', marginRight: '16px' }} src={logoEIT} alt="EIT Urban Mobility logo" />
                                    <img style={{ width: 'calc(50% - 8px)' }} src={logoEU} alt="Co-funded by EU" />
                                </Box>
                            </Grid>}
                        <Grid item md={4} sx={{ py: { md: 2, xs: 1 }, px: { md: 3, xs: 1 } }} textAlign={isBicification ? 'right' : 'center'}>
                            <Box sx={{ mr: 3 }}>
                                <img style={{ width: '100%', maxWidth: '20em', verticalAlign: 'middle' }}
                                    src={logo} alt="logo" />
                            </Box>
                        </Grid>
                    </Grid>
                </footer>
            </main>
        </Grid>
    );
}